import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    // Add Authorization header here if implementing auth:
    // 'Authorization': `Bearer ${token}`
  },
});

// Optional: Add interceptors for error handling or token refresh
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally if needed
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default api;
